
































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import "swiper/css/swiper.css";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
@Component({
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class Index extends Vue {
  SwiperIndex = {
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    speed: 100,
    slidesPerView: 1,
    loop: true,
    autoplay: true
  };
  @Prop()
  list!: [];

  jumpUrl(path) {
    if (path != "") {
      window.open(path, "_blank");
    }
  }
}
